import { useSelector } from 'react-redux';
import isEqual from 'lodash/isEqual';
import SeatMapProductModal from '../components/SeatMapProductModal';
import { getData } from '../utils/seatMapTransformer';
import { getTravelers } from '../utils/seatMapProductModalUtils';
import { getTravelerGender } from '../../common/utils/travelerGender';
import { getTravelerNames } from '../../common/utils/travelerNames';
import SeatMap from '../components/SeatMap';
import { jsx as _jsx } from "react/jsx-runtime";
const SeatMapContainer = ({
  form,
  isPostBooking,
  isSeatMapModalOpen,
  onSubmit,
  order,
  seatMapCallback,
  setIsSeatMapModalOpen,
  shouldRenderInline,
  travelerLabel
}) => {
  const travelerFormNames = useSelector(state => getTravelerNames(form, state, order.travelers || []), isEqual);
  const travelerFormGender = useSelector(state => getTravelerGender(form, state, order.travelers || []), isEqual);
  const travelers = getTravelers(order, travelerFormNames, travelerLabel, travelerFormGender);
  const bounds = getData(order);
  if (shouldRenderInline) {
    return /*#__PURE__*/_jsx(SeatMap, {
      bounds: bounds,
      form: form,
      isPostBooking: isPostBooking,
      onConfirm: onSubmit,
      shouldRenderInline: true,
      travelers: travelers
    });
  }
  return /*#__PURE__*/_jsx(SeatMapProductModal, {
    bounds: bounds,
    form: form,
    isPostBooking: isPostBooking,
    isSeatMapModalOpen: isSeatMapModalOpen,
    order: order,
    seatMapCallback: seatMapCallback,
    setIsSeatMapModalOpen: setIsSeatMapModalOpen,
    travelers: travelers
  });
};
export default SeatMapContainer;
//# sourceMappingURL=SeatMapContainer.js.map